// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScrollButton_wrapper__2c6Zs","inner":"ScrollButton_inner__GDIT0","innerPaddingBottom":"ScrollButton_innerPaddingBottom__dxwum","icon":"ScrollButton_icon__V_Bqf"};